import { render, staticRenderFns } from "./TextTermsAndCondition.vue?vue&type=template&id=87566e86&"
import script from "./TextTermsAndCondition.vue?vue&type=script&lang=js&"
export * from "./TextTermsAndCondition.vue?vue&type=script&lang=js&"
import style0 from "./TextTermsAndCondition.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports